import React from "react";

// DO NOT USE
// While this appears at first glance to be a more readable replacement for { condition && <RenderedItems />},
// it does not take advantage of the logical AND operator's (&&) short-circuiting,
// making it less performant and may unexpecteded evaluate the unrendered children, unlike &&.
export interface DeprecatedShowProps {
    when: boolean;
    fallback?: React.ReactNode;
    children?: React.ReactNode;
}

const DeprecatedShow: React.FC<DeprecatedShowProps> = ({
    when,
    fallback = <></>,
    children,
}) => {
    return when ? children : fallback;
};

export default DeprecatedShow;
